import DOMPurify from 'dompurify';
import {Marked} from 'marked';

const markdown = new Marked();
markdown.setOptions({
  breaks: true,
  gfm: true
});

const sortableTableSanitizerConfig = {
  ALLOWED_TAGS: [
    'a',
    'blockquote',
    'br',
    'code',
    'del',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'img',
    'li',
    'ol',
    'p',
    'pre',
    'strong',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'tr',
    'ul'
  ],
  ALLOWED_ATTR: ['align', 'alt', 'colspan', 'href', 'rowspan', 'scope', 'src', 'title'],
  ALLOW_ARIA_ATTR: false,
  ALLOW_DATA_ATTR: false,
  ALLOW_UNKNOWN_PROTOCOLS: false
};

function getColumnCount(content: string) {
  const [firstLine] = content.split(/\r?\n/g);
  return firstLine.split('|').filter((entry) => entry.length > 0).length;
}

export function renderSortableTableHtml(text: string, hasTotal: boolean) {
  if (!text) {
    return 'No content entered.';
  }

  // marked no longer expands tabs before parsing, and its table rule only accepts spaces in the
  // delimiter row, so a tab there makes the whole table parse as a paragraph.
  const source = text.replace(/\t/g, '    ');

  let html = markdown.parse(source) as string;
  const columnCount = getColumnCount(source);
  if (hasTotal && columnCount > 0) {
    const footerCells = Array.from({length: columnCount}, () => '<th></th>');
    html = html.replace('</tbody>', `</tbody><tfoot><tr>${footerCells.join('')}</tr></tfoot>`);
  }

  return DOMPurify.sanitize(html, sortableTableSanitizerConfig);
}
